import { api } from '@/utils/apiService';

const dealImageLibrary = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    searchLibrary: async (_, { q = '', limit = 24 } = {}) => {
      const response = await api.get('/deal-image-library/search', { params: { q, limit } });
      return response?.status === 200 ? response.data : [];
    },
    getGenerationStatus: async (_, { specialId, draftToken } = {}) => {
      const response = await api.get('/deal-image-library/generation-status', {
        params: { specialId, draftToken },
      });
      return response?.status === 200 ? response.data : null;
    },
    generateImage: async (_, payload) => {
      const response = await api.post('/deal-image-library/generate', payload);
      return response;
    },
    assignImage: async (_, payload) => {
      const response = await api.post('/deal-image-library/assign', payload);
      return response;
    },
    discardImage: async (_, { libraryImageId }) => {
      const response = await api.post('/deal-image-library/assign', {
        libraryImageId,
        accept: false,
      });
      return response;
    },
  },
};

export default dealImageLibrary;
